export var CouponScopeNamespace;
(function (CouponScopeNamespace) {
    CouponScopeNamespace["Stores"] = "stores";
    CouponScopeNamespace["Bookings"] = "bookings";
    CouponScopeNamespace["Events"] = "events";
    CouponScopeNamespace["PricingPlans"] = "pricingPlans";
    CouponScopeNamespace["Restaurants"] = "restaurants";
    CouponScopeNamespace["OnlinePrograms"] = "onlinePrograms";
})(CouponScopeNamespace || (CouponScopeNamespace = {}));
//# sourceMappingURL=namespace.js.map